class MPUtils {
    static ClampTextToDimensions (text, w, h) {
        if (text.width > w || text.height > h) {
            var scalar = Math.max(text.width / w, text.height / h);
            var textSize = parseInt(text.style.fontSize) / scalar;
            text.setFontSize(textSize - 1);
        }
    }
}

export default MPUtils;